import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { EmailTemplates } from "../../../../core/models/orders/emailTemplates";
import { LoaderService } from "../../../../core/services/loader.service";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { SamplepoSummaryService } from "../../../../core/services/samplepo-summary.service";
import { CommonModule } from "@angular/common";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { DisplayPdfFrameService } from "../../../../core/services/display-pdf-frame.service";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-display-pdf-frame",
  templateUrl: "./display-pdf-frame.component.html",
  imports: [
    CommonModule,
    SelectModule,
    ReactiveFormsModule,
    NgxExtendedPdfViewerModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
  styleUrls: ["./display-pdf-frame.component.scss"],
})
export class DisplayPdfFrameComponent implements OnInit {
  @Input() parent!: FormGroup;
  @Input() set templatesList(emailTemplates: EmailTemplates[]) {
    this.templates = emailTemplates;
    this.parent.patchValue({
      header: {
        templateId: this.templates[0]?.id,
      },
    });
  }
  @Input() poNumberRevision: string[] = [];
  @Input() poNumber = "";
  @Output() emailSelectionEvent = new EventEmitter();

  templates: EmailTemplates[] = [];
  poJournalPdf = "";

  constructor(
    private _loaderService: LoaderService,
    private _displayPdfFrameService: DisplayPdfFrameService,
    private _samplePOSummaryService: SamplepoSummaryService
  ) {}

  ngOnInit(): void {
    this.disabledpoNumber();
    this.getEmailPO();
    this.patchValueInPO();
    this.onPONumberSelection();
  }

  onEmailSelection() {
    this.emailSelectionEvent.emit();
  }

  disabledpoNumber() {
    this.parent.get(["header", "poNumber"])?.disable();
  }

  patchValueInPO() {
    this.parent.patchValue({
      header: {
        poNumber: this.poNumber,
      },
    });
  }

  getEmailPO() {
    this._loaderService.setLoaderState(true);
    this._samplePOSummaryService
      .getPurchaseOrderConfirmationJournal(this.poNumber)
      .subscribe({
        next: (res: GenericResponseDto<string>) => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() == "success") {
            if (res?.data) {
              this.poJournalPdf = res.data;
            }
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  onTemplateSelection($event: SelectChangeEvent) {
    this._displayPdfFrameService.onTemplatesSelection($event.value as number);
  }

  onPONumberSelection() {
    this._displayPdfFrameService.onPONumberSelection(this.poNumber);
  }
}
